import React, { Component } from "react";
import KeyboardEventHandler from "react-keyboard-event-handler";
import * as cx from "classnames";
import { Sticky, StickyContainer } from "react-sticky";
import ZoomIn from "../zoom_in.svg";
import ZoomOut from "../zoom_out.svg";
import RedXIcon from "../icons/red_x.svg";
import { imageUrl } from "../util";

const zoomStyles = [
  {
    maxHeight: "75vh",
    margin: "0 auto",
  },
  {
    maxWidth: "60vh",
    margin: "0 auto",
  },
  {},
];

class Carousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      index: 0,
      zoom: props.isMobile ? 1 : 2,
      currentImage: props.images[0],
      enlarged: true,
      hiddenScreenshots: [],
    };
  }
  zoom = zoom => () => {
    if (zoom === "out" && this.state.zoom > 0 && this.state.zoom !== 0) {
      this.setState({
        zoom: this.state.zoom - 1,
      });
    } else if (zoom === "in" && this.state.zoom < 2 && this.state.zoom !== 2) {
      this.setState({
        zoom: this.state.zoom + 1,
      });
    }
  };
  handleKeyEvent = (key, e) => {
    const { index } = this.state;
    const { images } = this.props;
    if (!images.length) {
      return;
    }

    const direction = key === "left" ? -1 : 1;
    let i = (index + direction + images.length) % images.length;

    // Continue wrapping until we hit a visible image, or conclude all are hidden.
    let attempts = 0;
    while (
      this.state.hiddenScreenshots.includes(i) &&
      attempts < images.length
    ) {
      i = (i + direction + images.length) % images.length;
      attempts++;
    }

    if (attempts >= images.length) {
      return;
    }

    this.setState({
      index: i,
      currentImage: images[i],
    });
  };
  handlePickImage = i => e => {
    e.preventDefault();
    if (this.state.hiddenScreenshots.includes(i)) {
      return;
    }
    this.setState({
      index: i,
      currentImage: this.props.images[i],
    });
  };
  toggleHiddenScreenshot = i => e => {
    e.preventDefault();
    e.stopPropagation();
    this.setState(prevState => {
      const hiddenScreenshots = [...prevState.hiddenScreenshots];
      if (hiddenScreenshots.includes(i)) {
        hiddenScreenshots.splice(hiddenScreenshots.indexOf(i), 1);
      } else {
        hiddenScreenshots.push(i);
      }
      return { hiddenScreenshots };
    });
  };
  render() {
    const { currentImage, index, zoom, hiddenScreenshots } = this.state;
    const { images } = this.props;
    let lStyles = zoomStyles[zoom];
    return (
      <StickyContainer>
        <Sticky>
          {({ style, isSticky }) => (
            <div
              className={cx({
                "mb2 bb b--white bg-white pb2": true,
                "b--black-20": isSticky,
              })}
              style={{ position: "relative", ...style }}
            >
              {images.map((img, i) => (
                <div
                  className={cx({
                    "mr2 pointer ba br3 b--white dib overflow-hidden relative": true,
                    "b--blue": index === i,
                    "o-50": hiddenScreenshots.includes(i),
                  })}
                  onClick={this.handlePickImage(i)}
                  key={`img_${i}`}
                >
                  <img
                    src={RedXIcon}
                    alt="remove thumbnail"
                    onClick={this.toggleHiddenScreenshot(i)}
                    className={cx(
                      "absolute top-0 right-0 mt1 mr1 pointer bg-white-90 br-100 pa1",
                      {
                        "o-50": hiddenScreenshots.includes(i),
                      }
                    )}
                    width="16"
                    height="16"
                  />
                  <div
                    className="overflow-hidden bg-light-gray ph2 pt2"
                    style={{ maxHeight: isSticky ? "30px" : "100px" }}
                  >
                    <img
                      src={imageUrl(img.src, 150, 100)}
                      width={isSticky ? 75 : 150}
                      alt="thumbnail"
                    />
                  </div>
                  <div
                    className={cx({
                      "pa2 bt b--light-gray f7": true,
                      "b--blue": index === i,
                    })}
                  >
                    <div className="flex">
                      <div className="w-100">
                        <b>{img.weight}</b>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      background: `url(${imageUrl(
                        img.src,
                        1150,
                        0,
                        1
                      )}) no-repeat -9999px -9999px`,
                    }}
                  />
                </div>
              ))}
              <div
                style={{
                  position: "absolute",
                  top: isSticky ? "10px" : "55px",
                  right: "0px",
                }}
              >
                <button
                  onClick={this.zoom("in")}
                  className={cx({
                    "pointer pa2 dib ba br3 b--black-10": true,
                    "shadow-1": this.state.zoom !== 2,
                    "bg-light-gray": this.state.zoom === 2,
                  })}
                  style={{ cursor: "pointer" }}
                >
                  <img src={ZoomIn} width="24px" alt="zoom in" />
                </button>
                <button
                  onClick={this.zoom("out")}
                  className={cx({
                    "pointer pa2 dib ba br3 b--black-10 ml2": true,
                    "shadow-1": this.state.zoom !== 0,
                    "bg-light-gray": this.state.zoom === 0,
                  })}
                  style={{ cursor: "pointer" }}
                >
                  <img src={ZoomOut} width="24px" alt="zoom out" />
                </button>
              </div>
            </div>
          )}
        </Sticky>
        <div className="w-100 tc">
          {currentImage && (
            <img
              src={imageUrl(currentImage.src, 1150, 0, 1)}
              style={lStyles}
              alt="selected"
            />
          )}
        </div>
        <KeyboardEventHandler
          handleKeys={["left", "right"]}
          onKeyEvent={this.handleKeyEvent}
        />
      </StickyContainer>
    );
  }
}

export default Carousel;
